export default __webpack_public_path__ + "static/media/assessment-evaluation.ada95b4c.svg";